"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textAndImageSectionPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

require("./text-and-image-section.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Text and Image Section v2, now with better spacing. Used for SMB section.
 */
// classnames for Contentful widths
var WIDTH_CLASS = {
  '25%': 'quarter',
  '33%': 'third',
  '50%': 'half',
  '66%': 'two-thirds',
  '75%': 'three-quarters',
  '100%': 'one'
}; // helper for retrieving from WIDTH_CLASS map

var getWidthClass = function getWidthClass(percent) {
  return _lodash["default"].get(WIDTH_CLASS, percent);
}; // Width class for text widths.


var OPPOSITE_WIDTH_CLASS = {
  quarter: 'three-quarters',
  third: 'two-thirds',
  half: 'half',
  'two-thirds': 'third',
  'three-quarters': 'quarter',
  one: 'two-thirds'
}; // helper for retreiving from OPPOSITE_WIDTH_CLASS map

var getRemainingWidth = function getRemainingWidth(widthClass) {
  return _lodash["default"].get(OPPOSITE_WIDTH_CLASS, widthClass);
};
/**
 * Helper for rendering Header.
 */


var HeaderElement = function HeaderElement(_ref) {
  var className = _ref.className,
      title = _ref.title,
      subTitle = _ref.subTitle;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, title, subTitle);
};

HeaderElement.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].node,
  subTitle: _propTypes["default"].node
};
HeaderElement.defaultProps = {
  className: null,
  title: null,
  subTitle: null
};
/**
 * UI for text and image section.
 * This is one section with two distinct containers.
 * The text container contains a header, some Markdown content, and a CTA.
 * The Image container contains a fluid image.
 *
 * There are 4 options for desktop layout:
 *  - Top Image Card
 *  - Bottom Image Card
 *  - Left Image Card
 *  - Right Image Card
 * On Mobile, these sections become one organized like:
 *  - Header
 *  - Image
 *  - Content
 *
 * @param {String} className Class given to the Text and Image section
 * @param {Node}   ctaButton Button react node
 * @param {String} ctaPosition Class determining CTA horizontal alignment
 * @param {String} displayType where to display the header on desktop. Mobile it's always on top.
 * @param {String} headerLocation See PropTypes for options.
 * @param {String} image Image url
 * @param {String} imageWidth See PropTypes for options.
 * @param {String} subTitle sub header
 * @param {String} title Main header
 * @param {Node}   wistiaButton Wistia Button react node
 */

var TextAndImageSection = function TextAndImageSection(_ref2) {
  var className = _ref2.className,
      ctaButton = _ref2.ctaButton,
      ctaPosition = _ref2.ctaPosition,
      displayType = _ref2.displayType,
      headerLocation = _ref2.headerLocation,
      image = _ref2.image,
      imageWidth = _ref2.imageWidth,
      subTitleText = _ref2.subTitle,
      bodyContent = _ref2.bodyContent,
      titleText = _ref2.title,
      wistiaButton = _ref2.wistiaButton;

  var title = titleText && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "title"
  }, titleText);

  var subTitle = subTitleText && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "subTitle"
  }, subTitleText);

  var isInlineHeader = headerLocation === 'inline'; // Render two headers if inline. Mobile header displays topLeft, desktop displays inline

  var headerClasses = isInlineHeader ? 'header inlineTop' : "header ".concat(_lodash["default"].camelCase(headerLocation));

  var header = (title || subTitle) && /*#__PURE__*/_react["default"].createElement(HeaderElement, {
    className: headerClasses,
    title: title,
    subTitle: subTitle
  }); // Desktop inline header


  var inlineHeader = isInlineHeader ? /*#__PURE__*/_react["default"].createElement(HeaderElement, {
    className: "header inline",
    title: title,
    subTitle: subTitle
  }) : null; // Determine width of image

  var imageWidthClass = imageWidth ? getWidthClass(imageWidth) : ''; // Text takes up remaining width

  var textSize = getRemainingWidth(imageWidthClass);

  var imageElement = image && /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: "",
    className: "image"
  });

  var textContent = bodyContent && /*#__PURE__*/_react["default"].createElement("div", {
    className: "textContent"
  }, bodyContent);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('TextAndImageSection-beta', className, displayType)
  }, header, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('contentWrapper', displayType)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('imageContainer', imageWidthClass)
  }, imageElement, wistiaButton), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('textContainer', textSize)
  }, inlineHeader, textContent, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('ctaWrapper', "ctaWrapper-".concat(ctaPosition))
  }, ctaButton))));
};

var textAndImageSectionPropTypes = {
  className: _propTypes["default"].string,
  ctaButton: _propTypes["default"].node,
  ctaPosition: _propTypes["default"].oneOf(['left', 'center', 'right']),
  displayType: _propTypes["default"].oneOf(['leftImageCard', 'rightImageCard', 'topImageCard', 'bottomImageCard']),
  headerLocation: _propTypes["default"].oneOf(['inline', 'topCenter', 'topLeft']),
  image: _propTypes["default"].string,
  imageWidth: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  bodyContent: _propTypes["default"].node,
  title: _propTypes["default"].string,
  wistiaButton: _propTypes["default"].node
};
exports.textAndImageSectionPropTypes = textAndImageSectionPropTypes;
TextAndImageSection.propTypes = textAndImageSectionPropTypes;
TextAndImageSection.defaultProps = {
  className: '',
  ctaButton: null,
  ctaPosition: 'left',
  displayType: 'leftImageCard',
  headerLocation: 'inline',
  image: null,
  imageWidth: null,
  subTitle: null,
  bodyContent: null,
  title: null,
  wistiaButton: null
};
var _default = TextAndImageSection;
exports["default"] = _default;